import { useState, useEffect } from 'react';
import { SupportFormUrls } from '../components/contact';
import { translatableText } from '../utils/translatable-text';
import { getLoginUrl } from '../utils/get-auth-url';
import { getLocalizedHref } from '../utils/get-localized-url';
import { getFeatureGate } from '../../statsig/statsig-client';
import { IC_FEATURE_FLAG } from '../utils/constants';

interface ContactLink {
    authenticated: HrefElement;
    needsAuthentication: HrefElement;
}

interface HrefElement {
    href: string;
    text: string;
}

const RELATIVE_CONTACT_URL = '/contact';

export const useSupportFormUrls = (customSupportFormURLs?: SupportFormUrls) => {
    const [supportFormLinks, setSupportFormLinks] = useState<ContactLink>({
        needsAuthentication: {
            text: '',
            href: ''
        },
        authenticated: {
            text: translatableText.contactSupport.text,
            href: '/contact'
        }
    });

    useEffect(() => {
        const updateSupportFormUrls = async function () {
            const isICEnabled = await getFeatureGate(IC_FEATURE_FLAG, false);

            setSupportFormLinks({
                needsAuthentication: {
                    text: translatableText.logInToContactSupport.text,
                    href: getLoginUrl(
                        customSupportFormURLs &&
                            customSupportFormURLs.authenticated
                            ? customSupportFormURLs.authenticated
                            : `${window.location.origin}${getLocalizedHref(
                                  RELATIVE_CONTACT_URL
                              )}`,
                        isICEnabled
                    )
                },
                authenticated: {
                    text: translatableText.contactSupport.text,
                    href:
                        customSupportFormURLs &&
                        customSupportFormURLs.authenticated
                            ? customSupportFormURLs.authenticated
                            : RELATIVE_CONTACT_URL
                }
            });
        };

        updateSupportFormUrls();
    }, [customSupportFormURLs]);

    return supportFormLinks;
};
